import React from 'react';

import './AmenitiesPageSkeleton.scss';

const AmenitiesPageSkeletonItem = () => (
  <div className="gridItem skeleton-item">
    <div className="skeleton-trigger">
      <div className="imgContainer">
        <div className="skeleton-image" />
        <div className="skeleton-title" />
      </div>
    </div>
  </div>
);

const AmenitiesPageSkeleton = () => (
  <div className="gridContainer">
    {[...Array( 6 )].map( ( _, index ) => (
      <AmenitiesPageSkeletonItem key={`skeleton-${index}`} />
    ) )}
  </div>
);

export default AmenitiesPageSkeleton;

